// extracted by mini-css-extract-plugin
export default {"melodyVideo":"lN-z","isFullWidth":"mN-z","landingPageVideo":"nN-z","play":"oN-z","iframeVideo":"pN-z","playHidden":"qN-z","fullwidth":"rN-z"};